import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { CssBaseline } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import '../../translations/i18n';

import { filterPollBuilderInitialIds } from './helpers/pollBuilder';
import {
  getPollBuilderMock,
  getPollResults,
  getUserData,
} from './services/PollBuilderService';
import {
  loadPollBuilder,
  loadPollChoices,
  loadSocialData,
  loadPollResults,
  loadUserData,
  changeTokenStatus,
} from '../../shared/redux/actions';
import App from './App';
import configureStore from '../../shared/redux/configureStore';
import theme from '../../theme/theme';
import { environment, sentryUrl } from '../../../globals';

if (environment !== 'development') {
  Sentry.init({
    dsn: sentryUrl,
    integrations: [
      new Integrations.BrowserTracing(),
    ],
    tracesSampleRate: 1.0,
    environment,
  });
}

const suitablePaths = ['/vote', '/mail'];
const checkPathname = (pathname) => {
  let result = false;
  suitablePaths.forEach((str) => {
    if (pathname.indexOf(str) > 0) {
      result = true;
    }
  });
  return result;
};

class Root extends Component {
  constructor(props) {
    super(props);
    this.store = configureStore();
  }

  componentDidMount() {
    const { pathname } = window.location;
    if (checkPathname(pathname)) {
      try {
        if (pathname.indexOf('/vote') > 0) {
          getPollBuilderMock()
            .then((questions) => {
              const choicesInitial = questions && filterPollBuilderInitialIds(questions);

              this.store.dispatch(loadPollBuilder(questions));
              this.store.dispatch(loadPollChoices({
                ...choicesInitial,
                proposals: '',
              }));
            });

          this.store.dispatch(loadSocialData());
        }

        getPollResults().then((results) => {
          this.store.dispatch(loadPollResults(results));
        });

        getUserData().then((data) => {
          this.store.dispatch(loadUserData(data.data && data.data));
          this.store.dispatch(changeTokenStatus(data.tokenStatus && data.tokenStatus));
        });
      } catch (e) {
        // do nothing
      }
    }
  }

  render() {
    return (
      <Provider store={this.store}>
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </MuiThemeProvider>
      </Provider>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById('root'));
